import { render, staticRenderFns } from "./CandidateServicesTable.vue?vue&type=template&id=c9899086&scoped=true&lang=pug"
import script from "./CandidateServicesTable.vue?vue&type=script&lang=ts"
export * from "./CandidateServicesTable.vue?vue&type=script&lang=ts"
import style0 from "./CandidateServicesTable.vue?vue&type=style&index=0&id=c9899086&prod&lang=sass&scoped=true"
import style1 from "./CandidateServicesTable.vue?vue&type=style&index=1&id=c9899086&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9899086",
  null
  
)

export default component.exports